import React from 'react';
import {
  Wallet, Receipt, Users, LayoutDashboard, FileText, Calendar, CreditCard,
  Tags, BarChart3, LineChart, ListOrdered, PieChart, Key, LogIn, LogOut,
  UserCircle, UserPlus, Bug, Globe, Menu, ChevronLeft, ChevronRight, ChevronDown,
  ChevronUp, ChevronsLeft, ChevronsRight, Upload, Download, Trash2, Pencil, Plus,
  Check, X, AlertCircle, Search, Sun, Moon, Eye, Image, Info, History, Hash,
  Coins, FileSpreadsheet, ArrowLeft, Banknote, Store, Settings, ShoppingCart,
  ShoppingBasket, LoaderCircle, Share2, Grid2x2, Link2, Unlink, RefreshCw, Scale,
} from 'lucide-react';

/* FontAwesome class names → Lucide components. Extend as the migration
   uncovers new names. Unmapped names log a one-time dev warning and
   render nothing. */
const MAP = {
  'fa-wallet':              Wallet,
  'fa-scale-balanced':     Scale,
  'fa-receipt':             Receipt,
  'fa-users':               Users,
  'fa-tachometer-alt':      LayoutDashboard,
  'fa-th-large':            Grid2x2,
  'fa-file-alt':            FileText,
  'fa-file-excel':          FileSpreadsheet,
  'fa-calendar':            Calendar,
  'fa-calendar-alt':        Calendar,
  'fa-calendar-week':       Calendar,
  'fa-credit-card':         CreditCard,
  'fa-link':                Link2,
  'fa-unlink':              Unlink,
  'fa-sync':                RefreshCw,
  'fa-tags':                Tags,
  'fa-chart-bar':           BarChart3,
  'fa-chart-line':          LineChart,
  'fa-chart-pie':           PieChart,
  'fa-list-ol':             ListOrdered,
  'fa-key':                 Key,
  'fa-sign-in-alt':         LogIn,
  'fa-sign-out-alt':        LogOut,
  'fa-user':                UserCircle,
  'fa-user-circle':         UserCircle,
  'fa-user-plus':           UserPlus,
  'fa-bug':                 Bug,
  'fa-globe':               Globe,
  'fa-bars':                Menu,
  'fa-chevron-right':       ChevronRight,
  'fa-chevron-down':        ChevronDown,
  'fa-chevron-up':          ChevronUp,
  'fa-angle-left':          ChevronLeft,
  'fa-angle-right':         ChevronRight,
  'fa-angle-double-left':   ChevronsLeft,
  'fa-angle-double-right':  ChevronsRight,
  'fa-arrow-left':          ArrowLeft,
  'fa-upload':              Upload,
  'fa-download':            Download,
  'fa-trash':               Trash2,
  'fa-pencil':              Pencil,
  'fa-plus':                Plus,
  'fa-check':               Check,
  'fa-times':               X,
  'fa-info-circle':         Info,
  'fa-history':             History,
  'fa-hashtag':             Hash,
  'fa-coins':               Coins,
  'fa-money-bill-wave':     Banknote,
  'fa-store':               Store,
  'fa-search':              Search,
  'fa-share-alt':           Share2,
  'fa-eye':                 Eye,
  'fa-image':               Image,
  'fa-spinner':             LoaderCircle,
  'fa-cog':                 Settings,
  'fa-shopping-cart':       ShoppingCart,
  'fa-shopping-basket':     ShoppingBasket,
  'fa-alert-circle':        AlertCircle,
  'fa-sun':                 Sun,
  'fa-moon':                Moon,
};

const SIZE_PX = { sm: 14, md: 16, lg: 20, xl: 24 };
const warned = new Set();

export default function Icon({
  name,
  size = 'md',
  strokeWidth = 1.75,
  className = '',
  ...rest
}) {
  if (!name) return null;

  const Cmp = MAP[name];
  if (!Cmp) {
    if (process.env.NODE_ENV !== 'production' && !warned.has(name)) {
      warned.add(name);
      // eslint-disable-next-line no-console
      console.warn(`[Icon] unmapped name "${name}" — add it to core/ui/Icon.js`);
    }
    return null;
  }

  const px = typeof size === 'number' ? size : SIZE_PX[size] ?? 16;

  return (
    <Cmp
      size={px}
      strokeWidth={strokeWidth}
      aria-hidden="true"
      className={className}
      {...rest}
    />
  );
}
